export default "__VITE_ASSET__CXrY4UbA__"